import Vue from 'vue'
import Vuex from 'vuex'
var fits = require("../mixin/lib-fits-front")

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        sConfig: null,
        sCrtType: null,
        sBKMenu: null,
        sTblid: "",
        sPassCode: "",
        sOrderH: null,
        sOrderI: [],
        sRst: [],
        sOrdertmp: [],
        sPhone: "",
        sPotype: "內用",
        sPoH: [],
        sPoI: [],
        sStopSale: [],
        sLastSendTime: "",
        sTimeTip: null,
        sCustCount: 0,
        // sOverSendTime: false,

        icons: {
            icon1: " <img style='height:1rem;' src='images/icon1.png'/> ",
            icon2: " <img style='height:1rem;' src='images/icon2.png'/> ",
            icon3: " <img style='height:1rem;' src='images/icon3.png'/> ",
            icon4: " <img style='height:1rem;' src='images/icon4.png'/> ",
            icon5: " <img style='height:1rem;' src='images/icon5.png'/> ",
            icon6: " <img style='height:1rem;' src='images/icon6.png'/> ",
            icon7: " <img style='height:1rem;' src='images/icon7.png'/> ",
            icon8: " <img style='height:1rem;' src='images/icon8.png'/> ",
            icon9: " <img style='height:1rem;' src='images/icon9.png'/> ",
            icon10: " <img style='height:1rem;' src='images/icon10.png'/> ",
            icon11: " <img style='height:1rem;' src='images/icon11.png'/> ",
            icon12: " <img style='height:1rem;' src='images/icon12.png'/> ",
            icon13: " <img style='height:1rem;' src='images/icon13.png'/> ",
            icon14: " <img style='height:1rem;' src='images/icon14.png'/> ",
            icon15: " <img style='height:1rem;' src='images/icon15.png'/> ",
            icon16: " <img style='height:1rem;' src='images/icon16.png'/> ",
            icon17: " <img style='height:1rem;' src='images/icon17.png'/> ",
            icon18: " <img style='height:1rem;' src='images/icon18.png'/> ",
            icon19: " <img style='height:1rem;' src='images/icon19.png'/> ",
            icon20: " <img style='height:1rem;' src='images/icon20.png'/> ",
            icon21: " <img style='height:1rem;' src='images/icon21.png'/> ",
            icon22: " <img style='height:1rem;' src='images/icon22.png'/> ",
            icon23: " <img style='height:1rem;' src='images/icon23.png'/> ",
            icon24: " <img style='height:1rem;' src='images/icon24.png'/> ",
            icon25: " <img style='height:1rem;' src='images/icon25.png'/> ",
            icon26: " <img style='height:1rem;' src='images/icon26.png'/> ",
            icon27: " <img style='height:1rem;' src='images/icon27.png'/> ",
            icon28: " <img style='height:1rem;' src='images/icon28.png'/> ",
            icon29: " <img style='height:1rem;' src='images/icon29.png'/> ",
            icon30: " <img style='height:1rem;' src='images/icon30.png'/> ",
            icon31: " <img style='height:1rem;' src='images/icon31.png'/> ",
            icon32: " <img style='height:1rem;' src='images/icon32.png'/> ",
            icon33: " <img style='height:1rem;' src='images/icon33.png'/> ",
            icon34: " <img style='height:1rem;' src='images/icon34.png'/> ",
            icon35: " <img style='height:1rem;' src='images/icon35.png'/> ",
            icon36: " <img style='height:1rem;' src='images/icon36.png'/> ",
            icon37: " <img style='height:1rem;' src='images/icon37.png'/> ",
            icon38: " <img style='height:1rem;' src='images/icon38.png'/> ",
            icon39: " <img style='height:1rem;' src='images/icon39.png'/> ",
            icon40: " <img style='height:1rem;' src='images/icon40.png'/> ",
        },
    },
    mutations: {
        setConfig(state, data) {
            state.sConfig = data;
        },
        setCrtType(state, obj) {
            state.sCrtType = obj;
        },
        setBKMenu(state, obj) {
            state.sBKMenu = obj;
        },
        setTblid(state, tblid) {
            state.sTblid = tblid;
        },
        setPassCode(state, code) {
            state.sPassCode = code;
        },
        setOCheck(state, obj) {
            state.sOrderH = obj.orderh;
            state.sOrderI = obj.orderi;
            let custTotal = 0
            if (obj.orderh) custTotal = fits.val(obj.orderh.CustTotal)
            state.sCustCount = custTotal;
        },
        setOrderTmp(state, obj) {
            state.sRst = obj.rst;
            state.sOrdertmp = obj.objs;
        },
        setUser(state, phone) {
            state.sPhone = phone;
        },
        setPotype(state, potype) {
            state.sPotype = potype;
        },
        setEaterPo(state, obj) {
            state.sPoH = obj.poh.reverse();
            state.sPoI = obj.poi;
        },
        setStopSale(state, data) {
            state.sStopSale = data;
            console.log("停售1", data)
        },
        setTimeTip(state, data) {
            state.sTimeTip = data;
        },
        setLastSendTime(state, pTime) {
            state.sLastSendTime = pTime;
            // console.log(pTime, "vs", fits.now(), pTime < fits.now())
            // if (pTime != "") {
            //     if (pTime < fits.now()) state.sOverSendTime = true;
            // }
        },

    },
    actions: {},
    modules: {},
    getters: {
        sGetConfig: (state) => (id) => {
            var config = state.sConfig;
            if (!config) {
                return "";
            }
            var find = Object.keys(config).find(r => r == id);
            if (!find) {
                console.log("Config not find: id = " + id);
                return "";
            }
            var value = state.sConfig[id].value;
            if (value == undefined) { return "" }
            return value;
        }
    }
})